import React, { useState } from 'react'
import { useEffect } from 'react'
import { connectStore } from 'redux-box';
import { module as activity } from 'store/activity'
import { module as ui } from 'store/ui'
import {
    AlignContentHorizontal, CardIcon
} from "static/styled/custom.styled";

import Select from 'react-select'
import './activityPacks_sync.css'
import { ThemeButton } from '../../../static/styled/custom.styled';

let platformsList = [
    {
        label: 'CMS',
        value: 'CMS'
    },
    {
        label: 'CBSE',
        value: 'CBSE'
    },
    {
        label: 'Hello',
        value: 'Hello'
    },
]
const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    control: (provide) => ({
        ...provide,
        width: "95%",
        margin: "0 auto",
        border: "none",
        boxShadow: "none",
    }),
};

const ActivityPacksSyncModal = ({ activity, ui }) => {

    const [platforms, setPlatforms] = useState([])
    const [selectedActivityPacks, setSelectedActivityPacks] = useState(activity.sync_activitypacks_list.map((str) => str.id))

    const handleCardClicked = (activity) => {
        if (selectedActivityPacks.includes(activity.id)) {
            setSelectedActivityPacks(prev => prev.filter((data) => data !== activity.id))
        } else {
            setSelectedActivityPacks(prev => [...prev, activity.id])
        }
    }

    const handleSyncNow = () => {
        let payload = {
            platforms: platforms.map((plt) => plt.value),
            activity_pack_ids: selectedActivityPacks
        }
        activity.syncActivityPacksToOtherPlatforms(payload)
        ui.hideModal()
    }

    const isChecked = (id) => selectedActivityPacks.some((item) => item === id);

    return (
        <div className='stories_sync_modal'>
            <p className='stories_sync_modal_header'>Sync activity packs to other platforms</p>
            <div className="table-container">
                <table className="info-table">
                    <thead>
                        <tr className='stories_sync_table_header_row'>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Grade Level</th>
                            <th>Description</th>
                            <th>Activity Count</th>
                            <th>Tags</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activity.sync_activitypacks_list && activity.sync_activitypacks_list.length > 0 ?
                            activity.sync_activitypacks_list.map((act, index) => {
                                // console.log(activity)
                                console.log('Checked?', act, isChecked(act.id), selectedActivityPacks);
                                return (
                                    <tr key={activity.id}>
                                        <td>
                                            <input type="checkbox" checked={isChecked(act.id)}
                                                onChange={() => handleCardClicked(act)} />
                                        </td>
                                        <td>{act.name}</td>
                                        <td>{act.grade_level}</td>
                                        <td>{act.description || "No description added."}</td>
                                        <td>{act.activity_count}</td>
                                        <td>{act.tag && act.tag.length > 0 ? act.tag.join(", ") : "No tags added."}</td>
                                    </tr>
                                )
                            })
                            :
                            <tr> No activity packs added to sync.</tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className="platforms_list_container">
                <p className="platforms_list_title">
                    Select Platforms
                </p>

                <Select
                    className="dropdown-container stories_sync_platform_select"
                    value={platforms}
                    onChange={(selectedSection) =>
                        setPlatforms(selectedSection)
                    }
                    options={platformsList}
                    placeholder="Select Platforms"
                    styles={customStyles}
                    menuPlacement="auto" // auto, top, or bottom
                    menuPosition="fixed"
                    isMulti={true}
                />
            </div>

            <ThemeButton primary onClick={handleSyncNow}>
                Sync Now
            </ThemeButton>
        </div>
    )
}

export default connectStore({
    activity, ui
})(ActivityPacksSyncModal)